module.exports = __webpack_public_path__ + "img/logo.f4fb90c9.jpg";